export class ExportarTransportistaDTO {
    [key: string]: any;
    docIdentificacion?: string;
    nombre?: string;
    apellido?: string;
    licencia?: string;
    empresa?: string;
    estado?: string;
}